module.exports = __webpack_public_path__ + "images/select-arrow-89887394.svg";